<template>
    <div>
        <div>
            <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
            <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
        </div>
        <md-card>
            <md-card-content>
                <md-layout md-gutter>
                    <md-layout md-flex="10">
                        <md-button class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                            @click="previousPoView">&laquo; Back</md-button>
                    </md-layout>
                    <md-layout md-flex="30"></md-layout>
                    <md-layout md-flex="40" class="mobile-width">
                        <h2>Response of Quotation</h2>
                    </md-layout>
                </md-layout>
                <b-row>
                    <b-col md="3">
                        <label for="location">Item Name</label>
                        <b-form-input :formatter="capitalizeAll" id="item_name"
                            :disabled="ResponseData.id_response_of_quotation != ''" name="item_name"
                            v-model="ResponseData.item_name"></b-form-input>
                    </b-col>
                    <b-col md="3" v-if="ResponseData.id_response_of_quotation == ''">
                        <md-button style="margin-top:35px;"
                            class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                            @click="addRefuelStation" id="addButtonLoader">Submit</md-button>
                        <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                    </b-col>
                    <b-col md="3"></b-col>
                    <b-col md="3"></b-col>
                </b-row>
                <b-row>
                    <b-col md="3" v-if="ResponseData.id_response_of_quotation != ''">
                        <label for="rqNumberAll">ROQ Series</label>
                        <model-list-select :list="RoqSeriesList" v-model="ResponseData.fk_RQ_ID" option-value="fk_RQ_ID"
                            option-text="RQseries" placeholder="Select RFQ Number"
                            @input="GetItemDetails(ResponseData.fk_RQ_ID)"></model-list-select>
                    </b-col>
                    <b-col md="9" v-if="ResponseData.fk_RQ_ID != '' && ResponseData.fk_RQ_ID != null">
                        <div class="table-responsive " style="width: 100%;">
                            <table border="1" style="display: table;border-color: #000;"
                                class="table table-bordered table-stripe table-responsive">
                                <tr>
                                    <th>SN.</th>
                                    <th>Item Name</th>
                                    <th>Quantity</th>
                                    <th>Remarks</th>
                                </tr>
                                <tr v-for="(item1,index) in ItemList" :key="index">
                                    <td>{{index+1}}</td>
                                    <td>{{item1.itemName}}</td>
                                    <td>{{item1.itemQuantity}}</td>
                                    <td>{{item1.remarks}}</td>
                                </tr>
                            </table>
                        </div>
                    </b-col>
                </b-row>
                <div class="mt-3" v-if="ResponseData.fk_RQ_ID != '' && ResponseData.fk_RQ_ID != null">
                    <b-row>
                        <b-col md="3">
                            <b-button id="show-btn" size="sm" variant="outline-primary" @click="AddMoreVendor">Add
                                Vendor <i class="fa fa-plus" aria-hidden="true"></i></b-button>
                        </b-col>
                    </b-row>
                    <b-card class="mt-2" v-for="(itm, idx) in VendorArray" :key="idx">
                        <b-row>
                            <b-col md="3">
                                <label for="location">Vendor Name <span class="error">*</span></label>
                                <b-form-input :formatter="capitalizeAll" id="vendor_name" name="vendor_name"
                                    v-model="itm.vendor_name"></b-form-input>
                                <span class="error" v-if="itm.vendor_name_err">{{ itm.vendor_name_err }}</span>
                            </b-col>
                            <b-col md="3">
                                <label for="location">Vendor Contact Person <span class="error">*</span></label>
                                <b-form-input :formatter="capitalizeAll" id="vendor_contact_person"
                                    name="vendor_contact_person" v-model="itm.vendor_contact_person"></b-form-input>
                                <span class="error" v-if="itm.vendor_contact_person_err">{{
                                    itm.vendor_contact_person_err }}</span>
                            </b-col>
                            <b-col md="3">
                                <label>State</label>
                                <model-list-select :list="$store.getters['common/getAllStateList']"
                                    v-model="itm.fk_state_id" option-value="stateId" option-text="stateName"
                                    placeholder="Select State "
                                    @input="getGSTCode(itm.fk_state_id, idx)"></model-list-select>
                            </b-col>
                            <b-col md="3">
                                <label for="location">Vendor GST No. (AAAAA1234A1Z5)</label>
                                <b-row>
                                    <div class="col-md-3">
                                        <b-form-input :formatter="capitalizeAll" name="gstCode" id="gstCode"
                                            v-model="itm.gstCode" disabled placeholder="GST Code"></b-form-input>
                                    </div>
                                    <div class="col-md-9">
                                        <b-form-input :formatter="capitalizeAll" name="vendor_gstNo" id="vendor_gstNo"
                                            v-model="itm.vendor_gstNo" placeholder="GST No"
                                            @keyup="GSTNValid(idx)"></b-form-input>
                                        <span class="error">{{GSTNErrorValid}}</span>
                                    </div>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="3">
                                <label for="location">Vendor Item Detail <span class="error">*</span></label>
                                <b-form-input :formatter="capitalizeAll" id="vendor_itemDetail" name="vendor_itemDetail"
                                    v-model="itm.vendor_itemDetail"></b-form-input>
                                <span class="error" v-if="itm.vendor_itemDetail_err">{{ itm.vendor_itemDetail_err
                                    }}</span>
                            </b-col>
                            <b-col md="3">
                                <label for="location">Vendor Contact Number</label>
                                <b-form-input :formatter="capitalizeAll" id="vendor_number" name="vendor_number"
                                    v-model="itm.vendor_number"></b-form-input>
                            </b-col>
                            <b-col md="3">
                                <label for="location">PAN No.(AAAAA1234A)</label>
                                <b-form-input :formatter="capitalizeAll" name="vendor_panNo" id="vendor_panNo"
                                    @keyup="PANErrorValid1(idx)" v-model="itm.vendor_panNo"></b-form-input>
                                <span class="error">{{ PANErrorValid }}</span>
                            </b-col>
                            <b-col md="3" v-if="itm.documentName != ''">
                                <div style="margin-top:30px;"
                                    v-if="itm.vend_master_flag != '1' && itm.isKYC != '0' && UserPermission != 'No' ">
                                    <input type="checkbox" id="AddVenMas" @click="openCloseVenodorAddModal(itm, idx)"
                                        v-model="isCheckAll" />
                                    <label for="AddVenMas">Add To Vendor Master</label>
                                </div>
                                <b-badge variant="danger" id="flagtrue" style="margin-top: 40px;"
                                    v-if="itm.vend_master_flag == '1'"> Already Added In Vendor Master</b-badge>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <label>Address <span class="error">*</span></label>
                                <b-textarea size="sm" :formatter="capitalizeAll" id="address" name="address"
                                    v-model="itm.vendor_Addr1" placeholder="Address"></b-textarea>
                                <span class="error" v-if="itm.vendor_Addr1_err">{{ itm.vendor_Addr1_err }}</span>
                            </b-col>
                            <b-col md="3">
                                <b-row>
                                    <b-col md="4">
                                        <b-button style="margin-top:40px" variant="outline-danger"
                                            @click="removeVendor(idx)" size="sm">Remove</b-button>
                                    </b-col>
                                    <b-col md="8"
                                        v-if="VendorArray.length > 0 && ResponseData.id_response_of_quotation != ''">
                                        <b-button style="margin-top:40px;padding:4px 7px;" variant="outline-primary"
                                            size="sm"
                                            @click="AddVendorMaster(itm, idx, 'Edit', ResponseData.id_response_of_quotation)">{{
                                            itm.documentName != '' && itm.documentName != null && itm.documentName !=
                                            undefined ? 'Edit' : 'Add' }} Doc </b-button>
                                        <b-button v-if="itm.documentName != '' && itm.documentName != null"
                                            style="margin-top:40px;padding:4px 7px;" variant="outline-primary" size="sm"
                                            @click="AddVendorMaster(itm, idx, 'View')">View Doc</b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col md="3" v-if="itm.vend_master_flag != '' && itm.vend_master_flag != '0'">
                                <b-button style="margin-top:40px;padding:4px 7px;" variant="outline-primary" size="sm"
                                    @click="goToMain(itm.id_response_vendor)">Create PO</b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </div>
                <b-row class="mt-5" v-if="ResponseData.id_response_of_quotation != ''">
                    <b-col md="4">
                        <md-button
                            class="md-raised md-primary md-button-color md-theme-default back heght-1px;display:block !important;"
                            @click="addRefuelStation" id="addButtonLoader">Update</md-button>
                        <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                    </b-col>
                    <b-col md="8">
                        <div v-if="ResponsePdf.length>0">
                            <span v-html="ResponsePdf">
                                {{ResponsePdf}}
                            </span>
                        </div>
                    </b-col>
                </b-row>
            </md-card-content>
        </md-card>
        <!-- Response Document Modal Added By Shreshth Gahlot Start -->
        <b-modal size="xl" class="" ref="KYC-modal" hide-footer
            :title="modalVendor.vendor_name+' KYC Document '+KYCviewType">
            <b-row v-if="UserPermission != 'No' && KYCviewType != 'Edit'">
                <b-col md="4" v-if="modalVendor.isKYC != '1'">
                    <input type="checkbox" :disabled="modalVendor.isKYC != '0'" id="AddKYC"
                        @click="isKYCcomplete(modalVendor.id_response_vendor, modalVendorIndex)" v-model="isCheckAll" />
                    <label for="AddKYC">Is KYC Complete</label>
                </b-col>
                <b-col md="4" v-else>
                    <b-badge variant="success" style="font-size:20px;margin-bottom: 10px;"> KYC Completed</b-badge>
                </b-col>
            </b-row>
            <table class="table table-bordered table-striped">
                <tbody>
                    <tr>
                        <th>SN.</th>
                        <th>Document Name</th>
                        <th v-if="KYCviewType != 'View'">Upload Document</th>
                        <th>View</th>
                        <th v-if="KYCviewType != 'View'">
                            <b-button class="mt-2" size="sm" variant="outline-info" @click="AddMoreDocs">Add More
                            </b-button>
                        </th>
                    </tr>
                    <tr v-for="(item, index) in showKYCSection" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>
                            <model-list-select v-model="item.documentName" :disabled="permissionStatus" :list="docList"
                                option-value="docV" option-text="docT"
                                placeholder="Select Document"></model-list-select>
                            <span class="error" v-if="item.documentName_err">{{ item.documentName_err }}</span>
                        </td>

                        <td v-if="KYCviewType != 'View'">
                            <md-input-container style="margin-top: -35px">
                                <md-file @selected="onFileChangeKyc(index, item.documentName)"
                                    v-model="item.document_KYC"></md-file>
                            </md-input-container>
                            <span class="error" v-if="item.document_KYC_err">{{ item.document_KYC_err }}</span>
                        </td>

                        <td>
                            <a @click="previewPrivateDocs(item.document_KYC)" class="showMoreData"
                                v-if="item.document_KYC != ''" target="_blank" download><u>View Document - {{ index + 1
                                    }}</u></a>
                        </td>

                        <td v-if="KYCviewType != 'View'">
                            <b-button variant="outline-danger" @click="removeDocKYC(index)" size="sm">Remove</b-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <b-row>
                <b-col class="my-3 text-center">
                    <b-button v-if="KYCviewType != 'View'" variant="outline-primary" id="addButtonLoader"
                        @click="KYCResponseDoc(modalResponseId)" size="sm">Save</b-button>
                    <b-button variant="outline-danger" class="ml-2" size="sm" @click="hideVendorMaster">Close</b-button>
                    <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
            </b-row>
        </b-modal>
        <!-- Document Type Modal Added By Shreshth Gahlot End -->

        <!-- Modal Section Start -->
        <b-modal no-close-on-esc no-close-on-backdrop size="md" ref="CloseConfirmation-modal" hide-footer title="">
            <div class="d-block text-center">
                <h3>Are you sure to want to add this Vendor to Vendor Master</h3>
            </div>
            <center>
                <span class="center">
                    <b-button class="mt-3" variant="success"
                        @click="AddToVendorMaster(VenodorAddClosedItems, VenodorAddClosedIndex)">Yes</b-button>
                    <b-button class="mt-3" variant="danger" @click="hideCloseVenodorAddModal">No</b-button>
                </span>
            </center>
        </b-modal>
        <!-- Modal Section End -->
        <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
        <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop1"
            @close="onClose1"></md-dialog-alert>
        <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop2"></md-dialog-alert>
    </div>
</template>
  
  <script>
    import DatePicker from "vue2-datepicker";
    import axios from "axios";
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
    import { DateFormat, selectDateFormat} from "../../../helper/filters.js";
    import { globalPermissionStatus } from "../../../helper/collection.js";
    import MaintenanceService from "../../../services/MaintenanceService.js";
    
    export default {
        beforeMount() {
            if(this.$sessionsStorage.get("editResponseId") != null){
                this.viewStockDetail();
            }
            if (globalPermissionStatus("Maintanence")) {
                this.$store.dispatch("setCurrentRoute", "/ResOfQuo/addResOfQuo");
                this.getData();
            } else {
                this.$router.push({
                    path: "/dashboard"
                });
            }
            this.$store.dispatch(
                "common/setAllStateList",
                JSON.stringify({
                itemCode: "StateList"
                })
            );
        },
        data() {
            return {
                selectDateFormat,
                docURL: URL_BASE_DOC,
                isLoading: false,

                isCheckAll: false,
                permissionStatus:
                    this.$sessionsStorage.get("PermissionStatus") != "" &&
                    this.$sessionsStorage.get("PermissionStatus") &&
                    this.$sessionsStorage.get("PermissionStatus") == "Read"
                    ? true
                    : false,
                alert: {
                    content:
                    this.$sessionsStorage.get("editResponseId") != "" &&
                    this.$sessionsStorage.get("editResponseId") != undefined
                        ? "Data Updated Succesfully"
                        : "Added Succesfully",
                    ok: "ok"
                },
                ResponseData: {
                    id_response_of_quotation: "",
                    fk_RQ_ID: "",
                    item_name: "",
                },
                docList: [
                    {
                        docV: "PAN_CARD",
                        docT: "PAN CARD",
                    },
                    {
                        docV: "ADDRESS_PROOF",
                        docT: "ADDRESS PROOF",
                    },
                    {
                        docV: "GST Certificate",
                        docT: "GST Certificate",
                    },
                    {
                        docV: "TAN",
                        docT: "TAN",
                    },
                    {
                        docV: "IEC",
                        docT: "IEC",
                    },
                    {
                        docV: "KYC",
                        docT: "KYC",
                    },
                    {
                        docV: "OTHERS",
                        docT: "OTHERS",
                    },
                ],
                Columns: [
                    {
                        key: "poItemId",
                        label: "SN",
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "itemName",
                        label: "Item Name",
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "itemQuantity",
                        label: "Item Quantity",
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "remarks",
                        label: "Remarks",
                        sortable: true,
                        sortDirection: "desc",
                    },
                ],
                ItemList: [],
                showKYCSection: [],
                validate: true,
                validateAddItem: true,
                maintenanceTypeError: "",
                locationError: "",
                addedByPersonError: "",
                VendorArray: [],
                GSTNErrorValid: "",
                PANErrorValid: "",
                poDateError: "",
                vendorNamError: "",
                vendorMaster: ["abc"],
                rqNumberAll: {},
                Roq_SeriesData: [],
                locationDetail: [],
                dapartmentDetail: [],
                vendorDetail: [],
                itemArrayShow: [],
                itemNameError: "",
                ratePerUnitError: "",
                itemQuantityError: "",
                itemCodeError: "",
                validateExp: true,
                validateKYC: true,
                modalVendor: "",
                modalVendorIndex: "",
                UserPermission: "",
                modalResponseId: "",
                ResponsePdf:"",
                VenodorAddClosedItems: "",
                VenodorAddClosedIndex: "",
                KYCviewType: "",
            };
        },
        watch: {
        },
        mounted() {
        // this.JqueryFun();
        },
        beforeDestroy() {},
        destroyed() {},
        components: {
            DatePicker,
            ModelListSelect,
            // Loading,
            CustomLoader,
            MaintenanceService,
        },
        computed: {  
            RoqSeriesList() {
                return this.Roq_SeriesData.length>0?this.Roq_SeriesData:[];
            },
        },
        methods: {
            GetItemDetails(id){    
                let payload = {
                    itemCode: "All_Item_For_Response",
                    RQ_ID: id,
                };
                MaintenanceService.EditDataMaintenance(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    if (status==200 && data) {
                        if (data.ItemData.length > 0) {
                            this.ItemList = data.ItemData;
                            // ResponseData.fk_RQ_ID
                        } else {
                            this.ItemList = '';
                        }
                    }
                })
                .catch(error => {});
            },
            openCloseVenodorAddModal(item, idx) {
                // alert(this.isCheckAll);
                console.log("idx=>", idx);
                if(this.isCheckAll==false){
                    this.VenodorAddClosedItems = item;
                    this.VenodorAddClosedIndex = idx;
                    this.$refs["CloseConfirmation-modal"].show();
                }
            },

            hideCloseVenodorAddModal() {
                this.isCheckAll=false;
                this.$refs["CloseConfirmation-modal"].hide();
                this.hideVendorMaster();
            },
            previewPrivateDocs(item) {
                //console.log("Shreshth Gahlot => ", pridel_doc);
                window.open(
                    `${this.docURL}/` + item
                );
            },
            goToMain(vendor_id) {
                this.$sessionsStorage.set("vendorName", "");
                this.$sessionsStorage.set("editPOId", "");
                if(vendor_id){
                    this.$sessionsStorage.set("vendorName", vendor_id);
                    this.$router.push({
                        path: "/poOrder/poOrder"
                    });
                } else {
                    this.alert.content = "Please Hello Checkbox";
                    this.$refs["addPop"].open();
                }
                
            },
            getGSTCode(state_id, index) {
                //alert(state_id);
                if (state_id) {
                    let gstCode = this.$store.getters["common/getAllStateList"].filter(
                    val => {
                        if (val.stateId == state_id) {
                            this.VendorArray[index].gstCode = val.gstCode;
                            this.VendorArray[index].state_name = val.stateName;
                        }
                    }
                    );
                } else {
                   this.VendorArray[index].gstCode = "";
                }
            },
            GSTNValid(index) {
                var gstinformat = new RegExp(
                    "^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                );

                if (gstinformat.test(this.VendorArray[index].vendor_gstNo)) {
                    this.GSTNErrorValid = "";
                } else {
                    this.GSTNErrorValid = "Please Enter Valid GSTN";
                }
            },
            PANErrorValid1(index) {
                var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");

                if (paninformat.test(this.VendorArray[index].vendor_panNo)) {
                    this.PANErrorValid = "";
                } else {
                    this.PANErrorValid = "Please Enter Valid PAN No.";
                }
            },
            removeVendor(index) {
                this.VendorArray.splice(index, 1);
            },
            removeDocKYC(index) {
                this.showKYCSection.splice(index, 1);
            },
            AddMoreDocs() {
                let obj = {
                    documentName: "",
                    document_KYC: "",
                    documentName_err: "",
                    document_KYC_err: "",
                };
                this.showKYCSection.push(obj);
            },
            AddMoreVendor() {
                let obj = {
                    id_response_vendor:"",
                    vendor_name: "",
                    vendor_contact_person: "",
                    vendor_email: "",
                    vendor_gstNo: "",
                    vendor_itemDetail: "",
                    vendor_Addr1: "",
                    fk_state_id: "",
                    documentName: "",
                    document_KYC: "",
                    isKYC: "",
                    vend_master_flag: "",
                    vendor_name_err: "",
                    vendor_contact_person_err: "",
                    vendor_itemDetail_err: "",
                    vendor_Addr1_err: "",
                };
                this.VendorArray.push(obj);
            },
            doLoading() {
                this.isLoading = true;
            },
            doLoadingClose() {
                this.isLoading = true;
        
                setTimeout(() => {
                this.isLoading = false;
                }, 500);
            },
            previousPoView() {
                this.$router.push({
                    path: "/responseOfQuo/responseOfQuo"
                });
            },
            getData() {
                if(this.ResponseData.item_name){
                    $("#loader").css("display", "none");
                    let payload = {
                        itemCode: "itemCode",
                        serviceEstimationId: "",
                        itemName: this.ResponseData.item_name,
                    };
                    MaintenanceService.fetchToStockIn(payload)
                    .then(result => {
                        const { statusText, status, data } = result;
                            console.log("Shreshth data.data => ",result);
                        if (status==200 && data) {
                            if (data.RequestForQuotation.length > 0) {
                                this.Roq_SeriesData = data.RequestForQuotation;
                                // ResponseData.fk_RQ_ID
                            } else {
                                this.Roq_SeriesData = '';
                            }
                        }
                    })
                    .catch(error => {});
                }
            },
            viewStockDetail() { 
                let payload = {
                    itemCode: "Response_Edit_Data",
                    id_response_of_quotation: this.$sessionsStorage.get("editResponseId"),
                };
                console.log("View Stock Detail => ", payload);
                MaintenanceService.EditDataMaintenance(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    if (status == 200 && data) {
                        console.log("Shreshth Gahlot Edit Data => ", data.editJob);
                        this.ResponseData = data.editJob[0];
                        this.UserPermission = data.MainPermission;
                        if(this.ResponseData.item_name){
                            this.getData();
                        }
                        if(data.VendorArray.length > 0) {
                            this.VendorArray = data.VendorArray;
                        } else {
                            this.VendorArray= [];
                        }
                        this.GetItemDetails(this.ResponseData.fk_RQ_ID);
                    }
                })
                .catch(error => {});
            },
            onClose(type) {
                this.$router.push({
                    path: "/ResOfQuo/addResOfQuo"
                });
            },
            onClose1() {
                this.itemArrayShow = [];
                let payload = {
                    poItemId: this.stockInDetails.poItemId,
                    view: "Request_Of_Quotation",
                };
                if (this.stockInDetails.RQ_ID != "") {
                    payload["fk_reqQuotationId"] = this.stockInDetails.RQ_ID;
                } else {
                    payload["fk_reqQuotationId"] = "";
                }

                let options = {
                    method: "POST",
                    url: `${URL_BASE}/Api_Maintenance/viewPoItems.php`,
                    data: JSON.stringify(payload),
                    crossDomain: true,

                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: this.$sessionsStorage.get("loginId")
                    }
                };

                axios(options)
                .then(result => {
                const { statusText, status, data } = result;
                if ( status == 200 && data) {
                    if (data.itemArray.length > 0) {
                        this.itemArrayShow = data.itemArray;
                        this.isLoading = false;
                    }
                }
                })
                .catch(error => {});
            },
            validateAddVendorArr() {
                let validate_new = true;
                let i = 0;
                let errCount = 0;
                let VenArr = this.VendorArray;
                for (let j = 0; j < VenArr.length; j++) {
                    if (VenArr[j].vendor_name == "") {
                        this.VendorArray[j]["vendor_name_err"] = "Vendor Name Field is Required";
                        validate_new = false;
                        ++errCount;
                    } else {
                        this.VendorArray[j]["vendor_name_err"] = "";
                        validate_new = true;
                    }

                    if (VenArr[j].vendor_contact_person == "") {
                        this.VendorArray[j]["vendor_contact_person_err"] = "Conatact Person Field is Required";
                        validate_new = false;
                        ++errCount;
                    } else {
                        this.VendorArray[j]["vendor_contact_person_err"] = "";
                        validate_new = true;
                    }

                    if (VenArr[j].vendor_itemDetail == "") {
                        this.VendorArray[j]["vendor_itemDetail_err"] = "Item Details Field is Required";
                        validate_new = false;
                        ++errCount;
                    } else {
                        this.VendorArray[j]["vendor_itemDetail_err"] = "";
                        validate_new = true;
                    }

                    
                    if (VenArr[j].vendor_Addr1 == "") {
                        this.VendorArray[j]["vendor_Addr1_err"] = "Vendor Address Field is Required";
                        validate_new = false;
                        ++errCount;
                    } else {
                        this.VendorArray[j]["vendor_Addr1_err"] = "";
                        validate_new = true;
                    }
                }

                if (errCount > 0) {
                    this.validateExp = false;
                }
                if (validate_new == false) {
                    this.validateExp = false;
                } else {
                    this.validateExp = true;
                }
            },
            addRefuelStation() {
                this.validateAddVendorArr();
                if (this.validateExp == false) {
                    this.alert.content = "PLEASE ENTER ALL DETAILS.";
                    this.$refs["addPop"].open();
                    return false;
                } else if (this.validate == false) {
                    this.alert.content = "PLEASE ENTER ALL DETAILS.";
                    this.$refs["addPop"].open();
                    return false;
                }
                console.log("this.VendorArray => ", this.VendorArray);
                if(this.VendorArray != ''){
                    this.ResponseData['VendorArray'] = this.VendorArray; 
                }
                console.log("ResponseData => ", this.ResponseData);
                // $("#addButtonLoader").css("display", "none");
                // $("#loader").css("display", "block");
                let payload = {
                    itemCode: "Add_ResponseData",
                    ResponseData: this.ResponseData,
                };
                console.log("Shreshth Gahlot Response payload => ", payload); 
                MaintenanceService.AddDataMaintenance(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    if ( status == 200 && data) {
                        if(data.id_response_of_quotation != ''){
                            this.ResponseData.item_name = '';
                            
                            this.$router.push({
                                path: "/responseOfQuo/responseOfQuo",
                            });
                            
                            this.alert.content = "Updated Successfully";
                            this.$refs["addPop"].open();
                        } else {
                            this.ResponseData.id_response_of_quotation = data.Id;
                            console.log("Data Successfully Insert => ", data);
                            if(data.PdfData){
                                this.ResponsePdf = data.PdfData;
                            }

                            this.alert.content = data.msg;
                            this.$refs["addPop"].open();

                            this.getData();
                        }
                    }
                })  
                .catch(error => {});
            },
            validateVendorKYC(){
                let validate_new = true;
                let i = 0;
                let errCount = 0;
                let showKYC = this.showKYCSection;
                for (let i = 0; i < showKYC; i++) {
                    if (showKYC[j].documentName == "") {
                        this.showKYCSection[i]["documentName_err"] = "Document Name Field is Required";
                        validate_new = false;
                        ++errCount;
                    } else {
                        this.showKYCSection[i]["documentName_err"] = "";
                        validate_new = true;
                    }

                    if (showKYC[i].document_KYC == "") {
                        this.showKYCSection[i]["document_KYC_err"] = "Upload Document Field is Required";
                        validate_new = false;
                        ++errCount;
                    } else {
                        this.showKYCSection[i]["document_KYC_err"] = "";
                        validate_new = true;
                    }
                }
                if (errCount > 0) {
                    this.validateKYC = false;
                }
                if (validate_new == false) {
                    this.validateKYC = false;
                } else {
                    this.validateKYC = true;
                }
            },
            KYCResponseDoc(id){
                console.log("this.showKYCSection => ", this.showKYCSection);
                this.validateVendorKYC();
                if (this.validateKYC == false) {
                    this.alert.content = "PLEASE ENTER ALL DETAILS.";
                    this.$refs["addPop"].open();
                    return false;
                }
                let payload = {
                    itemCode: "Add_VendorKYC",
                    fk_response_id: id,
                    showKYCSection: this.showKYCSection,
                };
                if(this.modalVendor != ''){
                    payload.modalVendor= this.modalVendor;
                }
                console.log("KYCResponseDoc Payload => ", payload);
                MaintenanceService.AddDataMaintenance(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    if ( status == 200 && data) {
                        console.log("Data Successfully Insert => ", data);
                        this.alert.content = data.msg;
                        this.$refs["addPop"].open();
                        //this.hideVendorMaster();
                        this.VendorArray[idx].fk_response_id = id;
                        this.isCheckAll=false;
                    }
                })  
                .catch(error => {});
            },
            AddVendorMaster(item, index, type, response_id){
                this.modalVendorIndex = "";
                this.modalVendor = "";
                this.KYCviewType = "";
                this.modalResponseId = "";
                this.modalVendorIndex = index;
                this.modalVendor = item;
                this.KYCviewType = type;
                this.modalResponseId = response_id;
                console.log("Document KYC console => ", this.KYCviewType);
                this.$refs["KYC-modal"].show();
                this.showKYC(item.id_response_vendor);
            },
            hideVendorMaster() {
                this.modalVendor = "";
                this.modalVendorIndex = "";
                this.KYCviewType = "";
                this.modalResponseId = "";
                this.$refs["KYC-modal"].hide();
                this.isLoading = false;
            },
            onFileChangeKyc(index, DOCNAME) {
                this.isLoading = true;
                let files = event.target.files || event.dataTransfer.files;
                let formData = new FormData();
                for (let i = 0; i < files.length; i++) {
                    formData.append("file[]", files[i]);
                    formData.append(
                        "moduleId",
                        this.$sessionsStorage.get("editClientId") + "-" + index
                    );
                    formData.append("staticFileName", this.modalVendor.vendor_name + "_" + DOCNAME);
                    formData.append("upload_dir_folderName", "RESPONSEKYCDOC");
                }
                console.log("Shreshth formData => ", formData);
                const config = {
                    headers: { "content-type": "multipart/form-data" },
                };

                axios
                .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
                .then((result) => {
                    console.log("Shreshth formData => ", result.data);
                    this.showKYCSection[index].document_KYC = result.data;

                    this.isLoading = false;
                })
                .catch((err) => {
                throw err;
                });
            },
            AddToVendorMaster(item, idx){
                let payload = {
                    itemCode: "Add_Vendor_Master_Maintenance",
                    VendorAddress: item,
                };
                //console.log("Vendor Master Payload => ", payload); return false;
                MaintenanceService.AddDataMaintenance(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    if (status == 200 && data) {
                        this.$sessionsStorage.set("vendorName", data.Id);
                        this.VendorArray[idx].vend_master_flag = data.vend_master_flag;
                        this.alert.content = data.msg;
                        
                        this.hideCloseVenodorAddModal();
                        this.$refs["addPop"].open();
                    }
                })  
                .catch(error => {});
            },
            showKYC(id){
                this.showKYCSection = [];
                let payload = {
                    itemCode: "Response_KYC_Data",
                    id_response_of_quotation: this.$sessionsStorage.get("editResponseId"),
                    id_response_vendor: id,
                };
                MaintenanceService.EditDataMaintenance(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    if (status == 200 && data.showKYCSection != '') {
                        if (data.showKYCSection[0].documentName != null && data.showKYCSection[0].document_KYC != "") {
                            let documentName = data.showKYCSection[0].documentName.split(",");
                            let document_KYC = data.showKYCSection[0].document_KYC.split(",");
                            for (let i = 0; i < document_KYC.length; i++) {
                                let obj = {
                                    documentName: documentName[i],
                                    document_KYC: document_KYC[i],
                                };
                                this.showKYCSection.push(obj);
                            }
                        } else {
                            this.showKYCSection = [];
                        }
                    } else {
                        this.showKYCSection = [];
                    }
                })
                .catch(error => {});
            },
            isKYCcomplete(id, idx){
                let payload = {
                    itemCode: "Check_KYC",
                    id_response_of_quotation: this.$sessionsStorage.get("editResponseId"),
                    id_response_vendor: id,
                };
                //console.log("payload => ", payload); return false; 
                MaintenanceService.AddDataMaintenance(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    if (status == 200 && data) {
                        this.alert.content = data.msg;
                        this.$refs["addPop"].open();
                        //this.hideVendorMaster();
                        this.VendorArray[idx].isKYC = 1;
                    } 
                })
                .catch(error => {});
            }
        }
    };
  </script>
  <style>
  .md-direction-bottom-right {
    width: 16% !important;
  }
  .b-form-input-container {
    margin: 4px 0 12px !important;
  }
  
  .activeClass {
    display: none;
  }
  .error {
    color: red;
  }
  .md-dialog-container.HereDialog.md-theme-default {
    z-index: 9999999;
  }
  .md-dialog-container.md-active{
    z-index: 9999999;
  }
  .md-dialog-container.HereDialog.md-theme-default .md-dialog {
    width: 50%;
    height: 50%;
  }
  .md-select-content {
    z-index: 999999999;
  }
  .marg-top {
    margin-top: 0%;
  }
  .md-card .md-card-content:last-child{
    height: 85vh;
  }
  @media (min-width:320px) and (max-width:767px) {
    .mobile-width{min-width: 100%;display:inline-block;}
    .md-card .md-card-content:last-child{height: auto !important;}
  }
  </style>


// WEBPACK FOOTER //
// addResponse.vue?1ddca71c